import { NgModule } from '@angular/core';

import { InitialsPipe } from './initials.pipe';

@NgModule({
   exports: [InitialsPipe],
   declarations: [InitialsPipe],
})
export class InitialsModule {}
